import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/Marquee";
import Services from "@/components/Services";
import Process from "@/components/Process";
import Lifecycle from "@/components/Lifecycle";
import WhyVeritas from "@/components/WhyVeritas";
import Numbers from "@/components/Numbers";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import AuthCallback from "@/components/AuthCallback";
import Admin from "@/pages/Admin";
import GoshtaLanding from "@/goshta/GoshtaLanding";
import { initLenis } from "@/lib/lenis";

function VeritasLanding() {
  useEffect(() => {
    initLenis();
  }, []);

  return (
    <div className="bg-[#050505] text-neutral-100 antialiased">
      <div className="grain-overlay" aria-hidden="true" />
      <Header />
      <main>
        <Hero />
        <EditorialMarquee />
        <Services />
        <Process />
        <Lifecycle />
        <WhyVeritas />
        <Numbers />
        <Contact />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function AppRouter() {
  const location = useLocation();
  // Detect OAuth callback synchronously during render (uses useLocation().hash, not window.location.hash)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<GoshtaLanding />} />
      <Route path="/veritas" element={<VeritasLanding />} />
      <Route path="/admin" element={<Admin />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <AppRouter />
      <Toaster theme="dark" position="bottom-right" />
    </BrowserRouter>
  );
}

export default App;
